import { createPortal } from "react-dom";
import { AlertTriangle, X, User } from "lucide-react";
import { useAtencionPrioritaria } from "../contexts/AtencionPrioritariaContext";

/**
 * Alerta parpadeante global de Atención Prioritaria. Montada una sola vez en el
 * root. Se renderiza vía portal a document.body con pointer-events propios para
 * quedar SIEMPRE por encima (y clickeable) sobre cualquier modal de Radix, que
 * aplica pointer-events:none al body cuando hay un Dialog abierto.
 */
export default function AtencionPrioritariaAlert() {
  const { alerta, cerrarAlerta } = useAtencionPrioritaria();
  if (!alerta) return null;

  return createPortal(
    <div
      className="ap-alert-overlay"
      data-testid="atencion-prioritaria-alert"
      role="alertdialog"
      aria-live="assertive"
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className="ap-alert-card">
        <button
          className="ap-alert-close"
          onClick={cerrarAlerta}
          data-testid="atencion-prioritaria-close"
          aria-label="Cerrar"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="ap-alert-icon">
          <AlertTriangle className="w-9 h-9" />
        </div>
        <h2 className="ap-alert-title" data-testid="atencion-prioritaria-title">
          DAR ATENCIÓN PRIORITARIA A ESTE CLIENTE
        </h2>
        <div className="ap-alert-client">
          <User className="w-5 h-5 mr-2 inline-block" />
          <span data-testid="atencion-prioritaria-cliente">{alerta.nombre_display}</span>
        </div>
        {alerta.motivo ? (
          <p className="ap-alert-motivo" data-testid="atencion-prioritaria-motivo">
            <strong>Motivo:</strong> {alerta.motivo}
          </p>
        ) : null}
        <p className="ap-alert-instr">
          No dejes a este cliente a medias. Si comenzaste a trabajarlo, complétalo lo antes posible.
        </p>
        {alerta.marcado_por_nombre ? (
          <p className="ap-alert-by">Marcado por {alerta.marcado_por_nombre}</p>
        ) : null}
        <button
          className="ap-alert-btn"
          onClick={cerrarAlerta}
          data-testid="atencion-prioritaria-ok"
        >
          Entendido
        </button>
      </div>
    </div>,
    document.body
  );
}
